module.exports = __webpack_public_path__ + "img/calendar1.7d4561b6.webp";